import Vue from 'vue'
import Vuex from 'vuex'
import axios from "axios"
import VueJwtDecode from "vue-jwt-decode"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    tokens: null,
    decodedToken: null,
    documents: [],
    labels: null,
    newLabels: null,
    authorities: [],
    classifications: [],
    types: [],
    docTypeLabels: [
      'direktoratets_afgørelse',
      'ama-afgørelse', 
      'folketings_ombudsmand',
      'direktoratets_vejledende_udtalelse',
      'ast-afgørelse',
      'cka-afgørelse',
      'cka-vejledende_udtalelse',
      'ams-afgørelse',
      'pensionsstyrelsen-vejledende_udtalelse',
      'sfr-afgørelse',
      'star-afgørelse',
      'stars-vejledende_udtalelse',
      'beskæftigelsesministeriets_afgørelse'
    ],
    loadingDocuments: true,
    macros: [
      {
        macro: '{% autoescape off %}',
        description: ''
      },
      {
        macro: '{{ RECIPIENT }}',
        description: 'Navnet på den modtager mailen sendes til'
      },
      {
        macro: '{{ CUTOFF_DATE }}',
        description: 'Den dato et dokument skal være oprettet efter, for at komme med i nyhedsbrevet'
      },
      {
        macro: '{% for DOCUMENT in DOCUMENTS %} {{DOCUMENT}} {% endfor %}',
        description: 'Viser de nyeste afgørelser baseret på den dato der er valgt'
      },
      {
        macro: '{% endautoescape %}',
        description: ''
      },
    ],
  },
  mutations: {
    SET_USER_DATA (state, data) {
      state.tokens = data
      state.decodedToken = VueJwtDecode.decode(data.access)
      sessionStorage.setItem("user", JSON.stringify(data))
    },
    CLEAR_USER_DATA() {
      sessionStorage.removeItem("user")
      location.reload()
    },
    ADD_LABELS (state, labels) {
      if (
        state.labels === null
      ) {
        state.labels = labels
      }
    },
    updateDocument(state, payload) {
      if (state.documents.some(record => { return record.id === payload.id })) {
        let document = state.documents.find(document => document.id === payload.id)
        let index = state.documents.indexOf(document)
        Vue.set(state.documents, index, payload)
      } else {
        console.debug(`Adding document ${payload.id} to store.`)
        state.documents.push(payload)
      }
    },
    ADD_AUTHORITY(state, payload) {
      if (!state.authorities.some(record => record.id === payload.id)) {
        state.authorities.push(payload)
      }
    },
    ADD_CLASSIFICATION(state, payload) {
      if (!state.classifications.some(record => record.id === payload.id)) {
        state.classifications.push(payload)
      }
    },
    ADD_TYPE(state, payload) {
      if (!state.types.some(record => record.id === payload.id)) {
        state.types.push(payload)
      }
    },
    ADD_NEW_LABELS(state, payload) {
      state.newLabels = payload
    }
  },
  actions: {
    login({ commit }, data) {
      commit("SET_USER_DATA", data)
    },
    getDocuments({ state, getters }, string) {
      state.loadingDocuments = true
      return new Promise((resolve, reject) => {
        axios.get('/api/search/' + string, getters.getConfig).then((response) => {
          state.loadingDocuments = false
          resolve(response)
        })
        .catch(error => {
          state.loadingDocuments = false
          reject(error)
        })
      })
    }
  },
  getters: {
    getDocument: state => id => {
      if (state.documents.find(document => document.id === parseInt(id))) {
        const document = state.documents.find(
          document => document.id === parseInt(id),
        )
        return document
      } else {
        return {}
      }
    },
    getConfig: state => {
      let config = null
      if (state.tokens && state.tokens.access) {
        config = {
          headers: {
            Authorization: "Bearer " + state.tokens.access
          }
        }  
      }
      return config
    },
    getCleanLabels: state => labels => {
      let cleanLabels = []
      let filteredLabels = labels.filter((label) => {
        if (label === 'adhocworkflow') {
          return false
        } else if (label === 'typisk' || label === 'principiel') {
          return false
        } else if (label === 'gældende_praksis' || label === 'ophævet_praksis') {
          return false
        } else if (state.docTypeLabels.includes(label)) {
          return false
        } if (!isNaN(label[0])) {
          return false
        }
        return true
      })
      for (let label of filteredLabels) {
        if (label.includes('taxonomi')) {
          for (let l of label.split('→')) {
            if (l !== 'taxonomi') cleanLabels.push(l)
          }
        } else {
          cleanLabels.push(label)
        }
      }
      return cleanLabels
    }
  },
  modules: {
  }
})
